import { SyntheticEvent, useState } from 'react';

import { Grid } from '@changegps/horizon-component-library';
import { Stack, Typography } from '@mui/material';

import { productDetails } from '../data/product-details';
import { useSubscriptionProducts } from '../store';

import { CustomTabs } from './CustomTabs';
import { ScrollableContainer } from './Filters.components';
import { ProductCard } from './ProductCard';

export const ProductsTable = () => {
  const products = useSubscriptionProducts();
  const [active, setActive] = useState<number>(0);

  const handleChange = (_event: SyntheticEvent, newValue: number): void => {
    setActive(newValue);
  };

  const ifTwoColumns = productDetails[active].length === 2;

  return (
    <Stack height={925}>
      <Typography fontSize={16}>WE DO THE TIME-CONSUMING STUFF.</Typography>
      <Typography fontSize={48} fontWeight={600} padding="10px 0px 10px">
        You do what matters.
      </Typography>
      <Typography fontSize={16} fontWeight={200}>
        Our packages take the legwork out of accounting-so you
      </Typography>
      <Typography fontSize={16} fontWeight={200}>
        can shine in the real work and radically improve your margins.
      </Typography>

      <CustomTabs value={active} handleChange={handleChange} />
      <ScrollableContainer>
        <Grid
          columnGap={6}
          sx={{
            gridTemplateColumns:
              productDetails[active].length === 2
                ? '.3fr 1fr 1fr .3fr'
                : productDetails[active].length === 1 ||
                    productDetails[active].length === 4
                  ? `repeat(3, 1fr)`
                  : `repeat(${productDetails[active].length}, 1fr)`,
          }}
        >
          {ifTwoColumns && <div />}
          {products[active].map((item, key) =>
            active !== 2 ? (
              <ProductCard
                key={key}
                active={active}
                {...item}
                length={productDetails[active].length}
              />
            ) : key === 2 ? (
              <Stack gap={4} key={key}>
                <ProductCard
                  active={active}
                  {...item}
                  length={productDetails[active].length}
                />
                <ProductCard
                  active={active}
                  {...productDetails[active][key + 1]}
                  length={2}
                />
              </Stack>
            ) : (
              key !== 3 && (
                <ProductCard
                  key={key}
                  active={active}
                  {...item}
                  length={productDetails[active].length}
                />
              )
            ),
          )}
          {ifTwoColumns && <div />}
        </Grid>
      </ScrollableContainer>
    </Stack>
  );
};
